import FinancialDetails from "../modules/Settings/Financial Details";
import PersonalDetails from "../modules/Settings/Personal Details";
import ReferAndEarn from "../modules/Settings/Refer";
import Subscription from "../modules/Settings/Subscriptions";
import Users from '../modules/Settings/Users/Users.jsx';

export const settingsBaseUrl = "/settings";

export const settingsRoutes = [
  {
    name: "Personal Details",
    url: "my-profile",
    component: PersonalDetails,
  },
  // {
  //   name: "Financial Details",
  //   url: "financial-details",
  //   component: FinancialDetails,
  // },
  {
    name: "Users",
    url: "users",
    component: Users,
  },
  // {
  //   name: "Subscription Invoice",
  //   url: "invoice",
  //   component: Subscription,
  // },
  // {
  //   name: "Refer and Earn",
  //   url: "refer",
  //   component: ReferAndEarn,
  // }
]


